import { findClosestSpot } from "./findClosestSpot";
import moment from "moment";

//This function filters the spots based on the date and season
export const SeasonFilter = (spot, date) => {
  const isInSeason = spot.seasons.some((s) => {
    let start = moment(s.start, "DD/MM").year(date.year());
    let end = moment(s.end, "DD/MM").year(date.year());

    if (end.isAfter(start)) {
      return date.isBetween(start, end) && s.type !== "protected";
    } else {
      return !date.isBetween(end, start) && s.type !== "protected";
    }
  });

  return isInSeason;
};

//This function filters the spots based on the wind
export const WindFilter = (spot, spots, weathers) => {
  const nearestSpot = findClosestSpot(spots, spot.gps[0].lat, spot.gps[0].long);
  const weather = !!weathers && weathers.find((w) => w.id === nearestSpot.id);
  if (!weather) {
    console.log("no weather for spot");
    console.log({ spot, spots, weathers });
    return false;
  }
  if (weather.windSpeed < 5) return true;

  return spot.wind.includes(parseInt(weather.windDeg));
};

//This function finds the current season for a spot based on the date
export const getSpotSeason = (spot, date) => {
  const currentSeason = spot.seasons.find((s) => {
    let start = moment(s.start, "DD/MM").year(date.year());
    let end = moment(s.end, "DD/MM").year(date.year());

    if (end.isAfter(start)) {
      return date.isBetween(start, end);
    } else {
      return !date.isBetween(end, start);
    }
  });

  return currentSeason.type || "low";
};
